import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"

const Wrapper = styled(Link)`
  padding: 15px 0;
  color: var(--text-color);
  font-weight: 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
  > div:nth-child(1) {
    > span {
      font-size: 14px;
    }
    > h4 {
      font-weight: bold;
      margin: 8px 0;
    }
    > p {
      font-size: 14px;
      margin: 0;
      opacity: 0.5;
    }
  }
`
const ResearchResult = ({ to, type, onClick, title, excerpt }) => {
  return (
    <Wrapper {...{ to, onClick }}>
      <div>
        <span>{type}</span>
        <h4>{title}</h4>
        <p>{excerpt}</p>
      </div>
    </Wrapper>
  )
}

ResearchResult.propTypes = {
  to: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export { ResearchResult }
